import template from 'text!./templates/local-date-chooser.html';

function localDate2Date(localDate) {
    return localDate ? new Date(localDate.year, localDate.month, localDate.day) : undefined;
}

function date2localDate(date) {
    return date ? {
        year: date.getFullYear(),
        month: date.getMonth(),
        day: date.getDate()
    } : undefined;
}

export default [function () {
    return {
        'restrict': 'AE',
        'template': template,
        'scope': {
            'model': '=',
            'maxDate': '=',
            'minDate': '=',
            'initialDate': '=',
            'data': '=',
            'startView': '@'
        },
        'controller': ['$scope', function ($scope) {
            $scope.value = localDate2Date($scope.model);
            $scope.initialDateV = localDate2Date($scope.initialDate || $scope.model);
            $scope.maxDateV = localDate2Date($scope.maxDate);
            $scope.minDateV = localDate2Date($scope.minDate);
            $scope.startView = $scope.startView || 'year';
            //Added new code to refresh data_MSF
            $scope.valueChanged = function () {
                $scope.$emit('dateChanged', $scope.data);
            };
            $scope.$watch('model', function (nv, ov) {
                if (nv !== ov) {
                    $scope.value = localDate2Date(nv);
                    $scope.initialDateV = localDate2Date($scope.initialDate || nv);
                }
            }, true);
            $scope.$watch('value', function (nv, ov) {
                if (nv !== ov) {
                    $scope.model = date2localDate(nv);
                }
            });
            $scope.$watch('initialDate', function (nv, ov) {
                if (nv !== ov) {
                    $scope.initialDateV = localDate2Date(nv || $scope.model);
                }
            });
            $scope.$watch('initialDateV', console.log, true);
        }]
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/time/LocalDateChooser.js
// module id = 2045
// module chunks = 0